// window.theme = window.theme || {};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}


function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class App {
  constructor() {
    this.calcHeaderAnnouncementBarHeight();
    this.calcViewport();
    this.eventListeners();
    this.addThemeInfo();
    this.setFirstSession();
    this.observeRTLChanges();
  }

  addThemeInfo() {
    if (window.theme === undefined) return;
    document.documentElement.setAttribute("data-theme-name", window.theme.info.name);
    document.documentElement.setAttribute("data-theme-version", window.theme.info.version);
  }

  isMobile() {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  isFirstSession() {
    return sessionStorage.getItem("firstSession") === null;
  }

  isRTL() {
    return document.documentElement.dir === 'rtl';
  }

  setFirstSession() {
    if (this.isFirstSession()) {
      sessionStorage.setItem("firstSession", true);
      document.documentElement.setAttribute("data-first-session", true);
    } else {
      document.documentElement.setAttribute("data-first-session", false);
    }
  }


  calcViewport() {
    let vh = window.innerHeight * 0.01;
    let vw = window.innerWidth * 0.01;

    document.documentElement.style.setProperty("--vh", `${vh}px`);
    document.documentElement.style.setProperty("--vw", `${vw}px`);
  }

  calcHeaderAnnouncementBarHeight() {
    let header = document.querySelector(".shopify-section-header");
    let announcementbar = document.querySelector(".shopify-section-announcement-bar");

    let height = 0;
    let headerHeight = header ? header.getBoundingClientRect().height : 0;
    let announcementbarHeight = announcementbar ? announcementbar.getBoundingClientRect().height : 0;

    document.documentElement.style.setProperty("--header-height", `${headerHeight}px`);
    document.documentElement.style.setProperty("--announcement-bar-height", `${announcementbarHeight}px`);


    height = headerHeight + announcementbarHeight;
    document.documentElement.style.setProperty("--top-content-height", `${height}px`);

    // return height;
  }

  onResize() {
    this.calcViewport();
    this.calcHeaderAnnouncementBarHeight();
  }

  observeRTLChanges() {
    const targetNode = document.documentElement; // Typically the <html> element
    const config = {
      attributes: true
    };

    const callback = (mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'dir') {
          this.isRTL = document.documentElement.getAttribute('dir') === 'rtl';
          this.emitRTLChange(); // Emit an event when direction changes
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }

  emitRTLChange() {
    const event = new CustomEvent('rtlChange', {
      detail: {
        isRTL: this.isRTL
      }
    });
    window.dispatchEvent(event);
  }

  eventListeners() {
    window.addEventListener("resize", this.onResize.bind(this));
  }
}

window.app = new App();

class AnnouncementBar extends HTMLElement {
  constructor(){
    super();

    this.items = Array.from(this.querySelectorAll('.announcement-bar__content li'));
    this.delay = this.dataset.interval;
    this.currentItemIndex = 0;

    // Run the animation if there are more than 1 announcement
    if (this.items.length > 1) {
      this.switchItems();
    }
  }

  connectedCallback() {
    this.setAttribute('role', 'alert');
    this.setAttribute('aria-live', 'assertive');
    this.toggleVisuallyHidden();
  }

  switchItems() {
    setInterval(() => {
      this.toggleVisuallyHidden();
      window.app.calcHeaderAnnouncementBarHeight();
    }, this.delay); 
  }

  toggleVisuallyHidden() {
    this.items.forEach((item, index) => {
      if (index === this.currentItemIndex) {
        item.classList.remove('visually-hidden');
        item.setAttribute('aria-hidden', 'false');
      } else {
        item.classList.add('visually-hidden');
        item.setAttribute('aria-hidden', 'true');
      }
    });
    this.currentItemIndex = (this.currentItemIndex + 1) % this.items.length;
  }
}

customElements.define("announcement-bar", AnnouncementBar);

class DropdownLink extends HTMLElement {
  constructor() {
      super();
  }

  connectedCallback() {
      this.href = this.getAttribute('href');
      this.current = this.getAttribute('data-current') === 'true';
      this.anchor = this.querySelector('a');
      this.anchor.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
      event.preventDefault();

      const parentElement = this.closest('li');
      const headerDropdown = parentElement.querySelector('.header__dropdown');

      const previousDropdowns = document.querySelectorAll('.header__dropdown.open');
      previousDropdowns.forEach((dropdown) => dropdown.classList.remove('open'));

      headerDropdown.classList.add('open');

      headerDropdown.addEventListener('focusin', (event) => event.stopPropagation());
      headerDropdown.addEventListener('focusout', () => {
          setTimeout(() => headerDropdown.classList.remove('open'), 0);
      });

      document.addEventListener('click', (event) => {
          const target = event.target;
          if (!this.contains(target) && !headerDropdown.contains(target)) {
              headerDropdown.classList.remove('open');
          }
      });
  }
}

customElements.define('dropdown-link', DropdownLink);
class HeaderDrawer extends HTMLElement {
  constructor() {
    super();

    this.hamburgerIcon = this.querySelector('#MenuDrawer-HamburgerIcon');
    this.closeIcon = this.querySelector('#MenuDrawer-CloseIcon');
    this.drawer = this.querySelector('#MenuDrawer');
    this.drawerInner = this.querySelector('.menu-drawer__wrapper');

    this.animate = gsap.timeline({
      paused: true,
      reversed: true,
    });

    this.animation();
    this.eventListeners();
  }

  toggle() {
    if (this.isDrawerOpen) {
      this.hideDrawer();
    } else {
      this.showDrawer();
    }

    this.animate.reversed() ? this.animate.play() : this.animate.reverse();
  }

  animation() {
    this.animate.fromTo(this.drawer, {
      display: 'none',
      autoAlpha: 0,
    }, {
      display: 'block',
      autoAlpha: 1,
      duration: 0.3,
    });
  }

  showDrawer() {
    this.isDrawerOpen = true;

    document.body.classList.add('overflow-hidden');
    this.closeIcon.style.display = 'inline-flex';
    this.hamburgerIcon.style.display = 'none';

    const containerToTrapFocus = this.drawer;
    const focusElement = this.drawerInner || this.closeIcon;
    trapFocus(containerToTrapFocus, focusElement);
  }

  hideDrawer() {
    document.body.classList.remove('overflow-hidden');

    this.closeIcon.style.display = 'none';
    this.hamburgerIcon.style.display = 'inline-flex';

    removeTrapFocus(document.activeElement);

    this.isDrawerOpen = false;
  }

  eventListeners() {
    this.hamburgerIcon.addEventListener('click', this.toggle.bind(this));
    this.closeIcon.addEventListener('click', this.toggle.bind(this));

    document.addEventListener('keydown', (e) => {
      if (e.keyCode === 27) {
        this.hideDrawer();
        this.animate.reverse();
      }
    });
  }
}

customElements.define('header-drawer', HeaderDrawer);

if (!customElements.get('localization-form')) {
  customElements.define('localization-form', class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
      this.hidePanel();
      event.stopPropagation();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const isChild = this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
      if (!event.relatedTarget || !isChild) {
        this.hidePanel();
      }
    }
  });
}

class MarqueeItem extends HTMLElement {
  constructor() {
    super();

    this.dataset.clone = this.dataset.clone || 3;

    this.clone();
    this.animate();
  }

  clone() {
    for (let i = 0; i < this.dataset.clone; i++) {
      var item = this.querySelector('div');
      var clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      item.after(clone);
    }
  }

  animate() {
    gsap.defaults({
      overwrite: true
    });

    const marquee = this.querySelectorAll('div');
    const speed = this.dataset.speed;
    const isReversed = this.dataset.reverse === 'true' ? true : false;

    const tl = gsap
      .fromTo(marquee, {
        xPercent: isReversed ? 0 : -100
      }, {
        duration: speed,
        xPercent: isReversed ? -100 : 0,
        ease: "none",
        repeat: -1
      })
      .timeScale(1);
  }
}

customElements.define('marquee-item', MarqueeItem);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');

    this.changeEvent = new Event('change', { bubbles: true })
    this.quantityUpdateEvent = new CustomEvent(PUB_SUB_EVENTS.quantityUpdate, {
      bubbles: true,
      detail: { value: 0 },
    });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.updateQuantity();
  }

  updateQuantity() {
    const value = parseInt(this.input.value);
    this.validateQtyRules(value);

    this.input.dispatchEvent(this.changeEvent);
    this.quantityUpdateEvent.detail.value = value;
    this.dispatchEvent(this.quantityUpdateEvent);
  }

  validateQtyRules(value) {
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);


class BackgroundVideo extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector('video');
    this.toggleSoundButton = this.querySelector('.toggle-sound');

    this.soundOnLabel = this.dataset.soundOnLabel;
    this.soundOffLabel = this.dataset.soundOffLabel;

    this.eventListeners();
  }

  isInViewport() {
    const rect = this.getBoundingClientRect();
    return (
      (rect.top >= 0 && rect.top <= window.innerHeight) ||
      (rect.bottom >= 0 && rect.bottom <= window.innerHeight)
    );
  }

  onToggleSound() {
    this.video.muted = !this.video.muted;
    this.toggleSoundButton.innerHTML = this.video.muted ? this.soundOnLabel : this.soundOffLabel;
    this.toggleSoundButton.setAttribute('aria-pressed', !this.video.muted);
  }

  onScroll() {
    if (this.isInViewport()) {
      this.video.play();
    } else {
      this.video.pause();
    }
  }

  eventListeners() {
    this.toggleSoundButton ? this.toggleSoundButton.addEventListener('click', this.onToggleSound.bind(this)) : null;
    this.toggleSoundButton ? this.toggleSoundButton.addEventListener('keydown', (e) => {
      if (e.keyCode === 13) {
        this.onToggleSound();
      }
    }) : null;

    window.addEventListener('scroll', debounce(this.onScroll.bind(this), 100));
  }
}
customElements.define('background-video', BackgroundVideo);


class ImageComparisonSlider extends HTMLElement {
  connectedCallback() {
    this.imageComparisonSlider = this.querySelector('[data-image-comparison-slider]');
    this.sliderRange = this.querySelector('[data-image-comparison-range]');
    this.imageComparisonOverlay = this.querySelector('[data-image-comparison-overlay]');

    this.initSlider();
    this.eventListeners();
  }

  initSlider() {
    this.updateSlider();
    this.setImageWidth();
  }

  updateSlider() {
    const sliderValue = this.sliderRange.value;
    const isRTL = window.app && typeof window.app.isRTL !== 'undefined' ? window.app.isRTL : false;

    gsap.set(this.imageComparisonOverlay, {
      width: `${sliderValue}%`
    });

    gsap.set(this.imageComparisonSlider, {
      left: isRTL ? `${sliderValue}%` : `${100 - sliderValue}%`
    });
  }

  setImageWidth() {
    const figure = this.imageComparisonOverlay.querySelector('figure');
    figure.style.width = `${this.getElementContentWidth(this)}px`;
  }

  getElementContentWidth(element) {
    const styles = window.getComputedStyle(element);
    const padding = parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight);
    return element.clientWidth - padding;
  }

  eventListeners() {
    this.sliderRange.addEventListener('input', (e) => {
      this.moveSliderRange(e.target.value);
    });

    this.sliderRange.addEventListener('change', (e) => {
      this.moveSliderRange(e.target.value);
    });

    window.addEventListener('resize', () => {
      this.onResize();
    });

    // Observe changes to the custom element
    const observer = new MutationObserver(() => {
      this.initSlider();
    });
    observer.observe(this, { attributes: true, childList: true, subtree: true });
  }

  onResize() {
    this.setImageWidth();
    this.updateSlider();
  }

  moveSliderRange(value) {
    const isRTL = window.app && typeof window.app.isRTL !== 'undefined' ? window.app.isRTL : false;

    gsap.to(this.imageComparisonSlider, {
      left: isRTL ? `${100 - value}%` : `${value}%`,
      duration: 0.3,
      ease: 'power2.out'
    });

    gsap.to(this.imageComparisonOverlay, {
      width: `${value}%`,
      duration: 0.3,
      ease: 'power2.out'
    });
  }
}

customElements.define('image-comparison-slider', ImageComparisonSlider);


class passwordVisibility extends HTMLElement {
  constructor() {
    super();

    this.passwordInput = this.querySelector('input');
    this.togglePasswordButton = this.querySelector('button');
    this.togglePasswordButtonSpans = this.querySelectorAll('button > span');
    this.togglePasswordButton.addEventListener('click', this.togglePasswordVisibility.bind(this));
  }

  togglePasswordVisibility(e) {
    e.preventDefault();
    if (this.passwordInput.type === 'password') {
      this.passwordInput.type = 'text';
      this.togglePasswordButton.setAttribute('aria-pressed', 'true');
      this.togglePasswordButtonSpans[0].classList.add('visually-hidden');
      this.togglePasswordButtonSpans[1].classList.remove('visually-hidden');
    } else {
      this.passwordInput.type = 'password';
      this.togglePasswordButton.setAttribute('aria-pressed', 'false');
      this.togglePasswordButtonSpans[0].classList.remove('visually-hidden');
      this.togglePasswordButtonSpans[1].classList.add('visually-hidden');
    }
  }
}

customElements.define('password-visibility', passwordVisibility);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateVariantId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }

    if (!this.currentVariant) return;
    this.dispatchEvent(
      new CustomEvent(PUB_SUB_EVENTS.variantChange, {
        bubbles: true,
        detail: { currentVariant: this.currentVariant, sectionId: this.currentVariant.id },
      })
    );
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateVariantId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
      
      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const quickAddModal = this.closest('quick-add-modal');
    if (!quickAddModal) {
      const media = document.getElementById(`ProductMedia-${this.dataset.section}`);
      const currentMedia = media.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      media.slider.selectCell(currentMedia);
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms =
      document.querySelectorAll(`#Product-Form-${this.dataset.section}, #Product-Form-Installment-${this.dataset.section}`);

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`Price-${this.dataset.section}`);
        const source = html.getElementById(`Price-${this.dataset.section}`);

        const stickyPriceDestination = document.getElementById(`StickyPrice-${this.dataset.section}`);
        const stickyPriceSource = html.getElementById(`StickyPrice-${this.dataset.section}`);

        const stickyAddToCartDestination = document.getElementById(`StickyAddToCart-${this.dataset.section}`);
        const stickyAddToCartSource = html.getElementById(`StickyAddToCart-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (stickyPriceSource && stickyPriceDestination) stickyPriceDestination.innerHTML = stickyPriceSource.innerHTML;
        if (stickyAddToCartSource && stickyAddToCartDestination) stickyAddToCartDestination.innerHTML = stickyAddToCartSource.innerHTML;

        const price = document.getElementById(`Price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text) {
    const productForm = document.getElementById(`Product-Form-${this.dataset.section}`);
    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const isPreorder = addButton.dataset.isPreorder === "true";

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = isPreorder ? window.variantStrings.preOrder : window.variantStrings.addToCart;
    }
  }

  setUnavailable() {
    const button = document.getElementById(`Product-Form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`Price-${this.dataset.section}`);

    if (!addButton) return;

    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
      pickUpAvailability.removeAttribute('available');
    } else {
      pickUpAvailability.innerHTML = '';
    }
  }
};
customElements.define('variant-selects', VariantSelects);


if (window.theme && window.theme.enablePredictiveSearch) {
  class SearchModal {
    constructor() {
      this.el = document.querySelector('.search-modal__container');

      if (!this.el) {
        return; // Exit constructor if the main element doesn't exist
      }

      this.elements = {
        searchIcon: document.querySelector('header .header__icon--search'),
        searchInput: this.el.querySelector('input[type="search"]'),
        searchModalWrapper: this.el.querySelector('.search-modal__wrapper'),
        searchModalOverlay: this.el.querySelector('.search-modal__overlay'),
        searchModalCloseBtn: this.el.querySelector('.search-modal__close-btn'),
        searchDefaultState: this.el.querySelector('.search-modal__default-state'),
        searchPredictiveResults: this.el.querySelector('[data-predictive-search]'),
        searchFeaturedKeywords: this.el.querySelectorAll('[data-featured-keyword]'),
      }

      this.cachedSearchResults = {};

      const timeline = gsap.timeline({
        ease: "power3.out",
        paused: true,
        reversed: true,
        onStart: () => {
          this.el.toggleAttribute('hidden');
        },
        onReverseComplete: () => {
          setTimeout(() => {
            this.el.toggleAttribute('hidden');
          }, 100);
        }
      });
      this.tl = timeline;

      this.animate();
      this.eventListeners();
    }

    animate() {
      this.tl.from(this.elements.searchModalOverlay, {
        autoAlpha: 0,
        duration: 0.2,
      }, 0)
        .fromTo(this.elements.searchModalWrapper, {
          autoAlpha: 0,
        }, {
          autoAlpha: 1,
          duration: 0.8
        }, 0.1)
    }

    open() {
      this.tl.play();
      this.tl.then(() => {
        const containerToTrapFocus = this.el;
        const focusElement = this.elements.searchModalWrapper;
        trapFocus(containerToTrapFocus, focusElement);
      });
      document.body.classList.add('search-modal-open');
      this.el.classList.add('desktop-only');
    }

    close() {
      this.tl.reverse();
      document.body.classList.toggle('search-modal-open');
      removeTrapFocus(this.activeElement);
      this.el.classList.remove('desktop-only');
    }

    toggle() {
      this.tl.reversed() ? this.open() : this.close();
    }

    getQuery() {
      return this.elements.searchInput.value;
    }

    onChange() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        this.elements.searchDefaultState.removeAttribute('hidden');
        this.elements.searchDefaultState.classList.remove('visually-hidden');

        this.elements.searchPredictiveResults.setAttribute('hidden', '');
        this.elements.searchPredictiveResults.classList.add('visually-hidden');

        return;
      }

      this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
      const queryKey = searchTerm.replace(" ", "-").toLowerCase();

      if (this.cachedSearchResults[queryKey]) {
        this.renderSearchResults(this.cachedSearchResults[queryKey]);
        return;
      }

      fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,page,article,collection&${encodeURIComponent('resources[limit]')}=4&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          this.cachedSearchResults[queryKey] = resultsMarkup;
          this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          throw error;
        })
    }

    renderSearchResults(resultsMarkup) {
      this.elements.searchDefaultState.setAttribute('hidden', '');
      this.elements.searchDefaultState.classList.add('visually-hidden');

      this.elements.searchPredictiveResults.innerHTML = resultsMarkup;

      this.elements.searchPredictiveResults.removeAttribute('hidden');
      this.elements.searchPredictiveResults.classList.remove('visually-hidden');
    }

    onFormSubmit() {
      if (!this.getQuery().length) {
        event.preventDefault();
      }
    }

    eventListeners() {
      this.elements.searchIcon.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggle();
      });

      this.elements.searchModalOverlay.addEventListener('click', () => {
        this.close();
      });

      this.elements.searchModalCloseBtn.addEventListener('click', () => {
        this.close();
      });

      if (this.elements.searchFeaturedKeywords) {
        this.elements.searchFeaturedKeywords.forEach((keyword) => {
          keyword.addEventListener('click', (e) => {
            e.preventDefault();
            this.elements.searchInput.value = keyword.innerText;
            this.onChange();
          });
        });
      }

      const form = this.el.querySelector('form.search');
      form.addEventListener('submit', this.onFormSubmit.bind(this));

      this.elements.searchInput.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
    }
  }
  new SearchModal();
}

class MulticolumnMedia extends HTMLElement {
  constructor() {
    super();

    this.multicolumnMedia = [...this.querySelectorAll('.multicolumn-media__item--media')];

    this.init();
  }

  init() {
    this.multicolumnMedia.forEach(container => {
      const video = container.querySelector('video');
      const playButton = container.querySelector('button');

      if (!video) return;

      playButton.addEventListener('click', () => {
        if (video.paused) {
          video.play();
          playButton.style.opacity = '0';
          playButton.setAttribute('aria-label', 'Pause the video');
          playButton.setAttribute('aria-pressed', 'true');
          playButton.setAttribute('aria-hidden', 'true');
        } else {
          video.pause();
          playButton.style.opacity = '1';
          playButton.setAttribute('aria-label', 'Play the video');
          playButton.setAttribute('aria-pressed', 'false');
          playButton.setAttribute('aria-hidden', 'false');
        }
      });

      video.addEventListener('ended', () => {
        playButton.style.opacity = '1';
        playButton.setAttribute('aria-label', 'Play the video');
        playButton.setAttribute('aria-pressed', 'false');
        playButton.setAttribute('aria-hidden', 'false');
      });
    });
  }
}

customElements.define('multicolumn-media', MulticolumnMedia);

class ProductStickyBar extends HTMLElement {
  constructor() {
    super();

    this.parent = this.closest('.product__container');
    this.buyButtons = this.parent.querySelector('.product__buy-buttons');
    this.isInViewClass = 'product__sticky-bar--in-view';

    this.observeIntersection();
    window.onscroll = this.onScrollHandler.bind(this);
  }

  addInViewClass() {
    this.classList.add(this.isInViewClass);
    this.setAttribute('aria-hidden', 'false');
    setTimeout(() => {
      this.removeAttribute('hidden');
    }, 100);
  }

  removeInViewClass() {
    this.classList.remove(this.isInViewClass);
    this.setAttribute('aria-hidden', 'true');
    setTimeout(() => {
      this.setAttribute('hidden', '');
    }, 100);
  }


  onScrollHandler() {
    this.footer = document.querySelector('.shopify-section-footer');
    this.footerRect = this.footer.getBoundingClientRect();

    this.position = window.pageYOffset + window.innerHeight;

    if (this.position > this.footer.offsetTop) {
      this.removeInViewClass();
    } else {
      if (!this.isInView) this.addInViewClass();
    }
  }

  observeIntersection() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.removeInViewClass();
          this.isInView = true;
        } else {
          this.addInViewClass();
          this.isInView = false;
        }
      });
    });

    this.observer.observe(this.parent);
  }
}

customElements.define('product-sticky-bar', ProductStickyBar);

class CamaSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.element = this.querySelector('[data-slider]');
    this.mount(this.element);

    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'childList') {
          this.slider.reloadCells();
        }
      });
    });

    const config = { childList: true, subtree: true };
    observer.observe(this, config);
  }

  mount(node, options = {}) {
    this.slider = new Flickity(node, {
      draggable: '>1',
      cellAlign: 'center',
      contain: true,
      freeScroll: true,
      adaptiveHeight: false,
      // wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      ...options
    });
  }

  unMount() {
    this.slider.destroy();
  }
}

customElements.define('cama-slider', CamaSlider);


class ProductMedia extends HTMLElement {
  connectedCallback() {
    this.element = this.querySelector('[data-slider]');
    this.thumbnails = this.querySelector('[data-product-thumbnails]');
    this.elementNotDraggable = this.querySelector('[data-draggable=false]');
    this.mount(this.element, this.thumbnails);

    window.addEventListener('resize', () => {
      this.resizeSliders();
    });
  }

  resizeSliders() {
    setTimeout(() => {
      this.slider.resize();
      this.sliderNav.resize();
    }, 1);
  }

  getCurrentMediaType() {
    const selectedCell = this.slider.selectedCell;
    const mediaType = selectedCell.element.dataset.mediaType;
    this.element.dataset.currentMediaType = mediaType;
  }

  mount(node, nodeThumbnails, options = {}) {
    window.pauseAllMedia();

    this.slider = new Flickity(node, {
      draggable: false,
      cellAlign: 'left',
      contain: true,
      accessibility: true,
      freeScroll: false,
      adaptiveHeight: true,
      // wrapAround: true,
      // watchCSS: true,
      prevNextButtons: true,
      pageDots: false,
      ...options
    });

    this.sliderNav = new Flickity(nodeThumbnails, {
      asNavFor: node,
      cellAlign: 'center',
      accessibility: true,
      contain: true,
      pageDots: false,
      prevNextButtons: false,
    });

    this.getCurrentMediaType();

    this.slider.on('select', () => {
      this.getCurrentMediaType();
    });

    this.slider.on('change', () => {
      window.pauseAllMedia();
    });

    if (!this.thumbnails) return;

    const thumbnailsButtons = this.thumbnails.querySelectorAll('.product-thumbnails__item button');

    thumbnailsButtons.forEach((button, index) => {
      button.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.slider.select(index);
        }
      });
    });
  }

  unMount() {
    this.slider.destroy();
    this.sliderNav.destroy();
  }

  onLoad() {
    this.unMount();
    this.mount(this.element, this.thumbnails);
  }

  onUnload() {
    this.unMount();
  }
}

customElements.define('product-media', ProductMedia);